import React from 'react';
import {connect} from "react-redux";
import Location from "./Location";
import {
    getCountriesAction,
    isLoadingAction, isMenuOpenAction,
    setCustomCountryCodeAction,
    setUserDataAction
} from "../../../redux/userdata-reducer";
import {changeStepAction, scrollToStepAction, setNextStepAction} from "../../../redux/flow-reducer";

const mapStateToProps = state => {

    let obj = {
        userData:state.userData,
        flow:state.flow,
    }

    return obj;
}

const mapDispatchToProps = dispatch => {

    let obj = {
        getCountries: (countries)       => {dispatch(getCountriesAction(countries));},
        setUserData: (UserData)         => {dispatch(setUserDataAction(UserData));},
        isLoading: (Loading)            => {dispatch(isLoadingAction(Loading));},
        setCustomCountryCode: (e, data) => {dispatch(setCustomCountryCodeAction(e, data));},
        setNextStep: (nextStep)         => {dispatch(setNextStepAction(nextStep));},
        changeStep: ()                  => {dispatch(changeStepAction());},
        scrollToStep: (stepId)          => {dispatch(scrollToStepAction(stepId));},
        isMenuOpen: (value)             => {dispatch(isMenuOpenAction(value));}
    }

    return obj;
}

const LocationContainer = connect(mapStateToProps, mapDispatchToProps)(Location);

export default LocationContainer;